import { Component, OnInit, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-common-button-toggler',
  templateUrl: './common-button-toggler.component.html',
  styleUrls: ['./common-button-toggler.component.css']
})
export class CommonButtonTogglerComponent implements OnInit {

  @Output() buttonTogglerEvent = new EventEmitter<any>();

  constructor() { }

  ngOnInit(): void {
  }

  noteChecker : any=true;
  taskChecker : any=true;
  decisionChecker : any=true;

  toggleSelector(event : any){
    let arrayValue = event.value;
    let notes = 'notes';
    let task = 'task';
    let decision = 'decision';
    let noteIcon = <HTMLElement>document.getElementById('notes-icon');
    let taskIcon = <HTMLElement>document.getElementById('task-icon');
    let decisionIcon = <HTMLElement>document.getElementById('decision-icon')
    if(arrayValue.includes(notes) == true){
      this.noteChecker = true;
      noteIcon.setAttribute('style','color:white')
    }
    else{
      this.noteChecker = false;
      noteIcon.removeAttribute('style')
    }
    if(arrayValue.includes(task) == true){
      this.taskChecker = true;
      taskIcon.setAttribute('style','color:white')
    }
    else{
      this.taskChecker = false;
      taskIcon.removeAttribute('style')
    }
    if(arrayValue.includes(decision) == true){
      this.decisionChecker = true;
      decisionIcon.setAttribute('style','color:white')
    }
    else{
      this.decisionChecker = false;
      decisionIcon.removeAttribute('style')
    }
    this.buttonTogglerEvent.emit(arrayValue)
    
  }

}
